import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const settingsBaseUrl = '/api/setting';

export type RegisterOption = {
  label: string;
  value: string;
};

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getSelfRegisterList: builder.query<RegisterOption[], number>({
      query: (pvGroupID) => ({
        url: `${settingsBaseUrl}/self-register-list`,
        method: 'GET',
        params: { pvGroupID },
      }),
    }),
  }),
});

export const { useGetSelfRegisterListQuery } = settingsApi;
